// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /award/get-for-account.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeAwardGetForAccountBody,
  typeAwardGetForAccountOutput200,
} from "../../sdk/award/postAwardGetForAccount";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildAwardGetForAccountQueryKey(
  payload: typeAwardGetForAccountBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`accountId:${JSON.stringify(payload.accountId)}`);
  return [
    "post:award:awardGetForAccount",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeAwardGetForAccountOutput200,
    unknown,
    typeAwardGetForAccountOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useAwardGetForAccount(
  payload: typeAwardGetForAccountBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildAwardGetForAccountQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postAwardGetForAccount(payload),
    ...resolvedOptions,
  });
}
